import {useEffect} from 'react';
import useLatest from '../latest';

function useUnmount(fn: () => void) {
    const fnRef = useLatest(fn);
    useEffect(
        () => () => {
            fnRef.current();
        },
        []
    );
}

export default useUnmount;